var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgTrucks = function SvgTrucks(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0781 11.3333H12.5V13.8333H15.8334V12.6772L14.0781 11.3333ZM12.5 9.66667C11.5796 9.66667 10.8334 10.4129 10.8334 11.3333V13.8333C10.8334 14.7538 11.5796 15.5 12.5 15.5H15.8334C16.7539 15.5 17.5 14.7538 17.5 13.8333V12.6772C17.5 12.1584 17.2585 11.6692 16.8466 11.3538L15.0913 10.01C14.8005 9.78733 14.4444 9.66667 14.0781 9.66667H12.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00004 17.1667C5.46028 17.1667 5.83337 16.7936 5.83337 16.3333C5.83337 15.8731 5.46028 15.5 5.00004 15.5C4.5398 15.5 4.16671 15.8731 4.16671 16.3333C4.16671 16.7936 4.5398 17.1667 5.00004 17.1667ZM7.50004 16.3333C7.50004 17.714 6.38075 18.8333 5.00004 18.8333C3.61933 18.8333 2.50004 17.714 2.50004 16.3333C2.50004 14.9526 3.61933 13.8333 5.00004 13.8333C6.38075 13.8333 7.50004 14.9526 7.50004 16.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 17.1667C12.9603 17.1667 13.3334 16.7936 13.3334 16.3333C13.3334 15.8731 12.9603 15.5 12.5 15.5C12.0398 15.5 11.6667 15.8731 11.6667 16.3333C11.6667 16.7936 12.0398 17.1667 12.5 17.1667ZM15 16.3333C15 17.714 13.8808 18.8333 12.5 18.8333C11.1193 18.8333 10 17.714 10 16.3333C10 14.9526 11.1193 13.8333 12.5 13.8333C13.8808 13.8333 15 14.9526 15 16.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8334 7.16667H2.50004L2.50004 13.8333H10.8334V7.16667ZM2.50004 5.5C1.57957 5.5 0.833374 6.24619 0.833374 7.16667V13.8333C0.833374 14.7538 1.57957 15.5 2.50004 15.5H10.8334C11.7538 15.5 12.5 14.7538 12.5 13.8333V7.16667C12.5 6.24619 11.7538 5.5 10.8334 5.5H2.50004Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 8.00002H16.5781L18.3333 9.34387V10.5C17.9235 10.5 17.5913 10.8322 17.5913 11.2421V11.4246C17.5913 11.8345 17.9235 12.1667 18.3333 12.1667C19.2538 12.1667 20 11.4205 20 10.5V9.34387C20 8.8251 19.7584 8.3359 19.3465 8.02053L17.5913 6.67668C17.3004 6.45401 16.9444 6.33335 16.5781 6.33335H15V3.83335C15 2.91288 14.2538 2.16669 13.3333 2.16669H4.99998C4.07951 2.16669 3.33331 2.91288 3.33331 3.83335V4.00004C3.33331 4.46028 3.70641 4.83337 4.16665 4.83337C4.62688 4.83337 4.99998 4.46028 4.99998 4.00004V3.83335H13.3333V7.00002C13.3333 7.5523 13.781 8.00002 14.3333 8.00002Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.833313 2.16669)"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgTrucks);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/Trucks.8c6870c2817a387f143ef7f1b6b0be92.svg";